import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { ILicense } from "types/licenseTypes"

interface LicenseState {
  licenses: Array<ILicense>
  currentLicense: ILicense | undefined
}

const initialState: LicenseState = {
  licenses: [] as ILicense[],
  currentLicense: undefined,
}

export const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    setLicenses: (state, action: PayloadAction<Array<ILicense>>) => {
      state.licenses = action.payload
    },
    setCurrentLicense: (state, action: PayloadAction<ILicense>) => {
      state.currentLicense = action.payload
    },
    addLicense: (state, action: PayloadAction<ILicense>) => {
      state.licenses = state.licenses.concat(action.payload)
    },
    addLicenses: (state, action: PayloadAction<Array<ILicense>>) => {
      state.licenses = state.licenses.concat(action.payload)
    },
    updateLicense: (state, action: PayloadAction<ILicense>) => {
      var index = state.licenses.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.licenses[index] = action.payload
      }
    },
    removeLicense: (state, action: PayloadAction<ILicense>) => {
      var index = state.licenses.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.licenses.splice(index, 1)
      }
    },
    resetLicense: (state, _action) => {
      state.licenses = []
      state.currentLicense = undefined
    },
  },
})

export const {
  setLicenses,
  addLicense,
  addLicenses,
  updateLicense,
  removeLicense,
  setCurrentLicense,
  resetLicense,
} = licenseSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.license

export default licenseSlice.reducer
